import React from "react";
import { ReactComponent as InformationCircle } from "images/icons/information-circle.svg?react";
import { StorefrontConfig } from "../types/storefront";

const UnsupportedFulfillmentMethodBanner = ({
  config,
}: {
  config: StorefrontConfig;
}): React.JSX.Element => {
  return <div className="container space-mt-lg">
    <div className="callout has-coloured-icon">
      <InformationCircle className="icon streamline-icon"/>
      <div>
        <div className="title">
           This store doesn&apos;t offer pickup
        </div>

        <p>
          View items for delivery or browse other places with in-store pickup 
        </p>
      </div>
    </div>
    <div>
      <form action="/restaurants/change_delivery_type" method="post">
        <input
          type="hidden"
          name="authenticity_token"
          autoComplete="off"
          value={config.csrfToken}
        />

        <input
          type="hidden"
          name="redirect_to"
          autoComplete="off"
          value={window.location.href}
        />

        <input
          type="hidden"
          name="storefront_id"
          autoComplete="off"
          value={config.storefrontId}
        />
        <input
          type="hidden"
          name="fulfillment_method"
          id="fulfillment_method_delivery"
          value="delivery"
        />

        <input
          type="submit"
          name="fulfillment_method"
          id="fulfillment_method_delivery"
          value="View for delivery"
          className="button is-primary space-mr-sm space-mt-sm"
        />
        <a className="button space-mt-sm" href="/">
          <span>See pickup stores</span>
        </a>
      </form>
    </div>
  </div>
}

export { UnsupportedFulfillmentMethodBanner }
